import "./loading.css"

export function LoadingIcon() {
  return <div className="loading"></div>;
}
